window.GeoNotice = {
    _country: null,
    _callbacks: [],
    detectCountry: function(callback){
        if(this._country !== null){
            callback(this._country);
            return;
        }
        this._callbacks.push(callback);

        if(this._callbacks.length > 1) return;

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { credentials: 'same-origin' })
            .then(r => r.ok ? r.json() : Promise.reject(r))
            .then(data => {
                this._country = data.detected_values?.country?.handle || null;
                this._callbacks.forEach(cb => cb(this._country));
                this._callbacks = [];
            })
            .catch(() => {
                this._country = null;
                this._callbacks.forEach(cb => cb(this._country));
                this._callbacks = [];
            });
    },
    isCountry: function(code, callback){
        this.detectCountry(c => callback(c === code));
    }
};
